/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import App from './App.vue';
import Vuesax from 'vuesax'; // Vuesax Component Framework
import axios from './axios.js'; // axios
import './http/requests'; // API Calls
import '../themeConfig.js'; // Theme Configurations
import './globalComponents.js'; // Globally Registered Components
import router from './router'; // Vue Router
import store from './store/store'; // Vuex Store
import i18n from './i18n/i18n'; // i18n
import './filters/filters'; // Vuesax Admin Filters
import VueClipboard from 'vue-clipboard2'; // Clipboard
import VeeValidate from 'vee-validate'; // VeeValidate
import { VueHammer } from 'vue2-hammer'; // Vuejs - Vue wrapper for hammerjs
import { abilitiesPlugin } from '@casl/vue';
import appInfo from './http/requests/app/index.js';
import * as Sentry from "@sentry/vue";

Vue.use(Vuesax);
Vue.prototype.$http = axios;
Vue.use(VueClipboard);
Vue.use(VeeValidate, { fieldsBagName: 'formFields' });
Vue.use(VueHammer);

// Feather font icon
require('@assets/css/iconfont.css');

Vue.config.productionTip = false;

Vue.use(abilitiesPlugin, store.getters.ability);

if ((process.env.MIX_APP_ENV === 'production' || process.env.MIX_APP_ENV === 'dev')) {
    Sentry.init({
        Vue: Vue,
        dsn: "https://2c0c36ee3a86102709a1148d7423645e@o4508992716668928.ingest.de.sentry.io/4509055089770576",
        integrations: [
            Sentry.browserTracingIntegration({ router }),
        ],
    });
}

// https://stackoverflow.com/questions/41572974/how-to-load-all-server-side-data-on-initial-vue-js-vue-router-load
store.dispatch('initApp')
    .then(() => {
        new Vue({
            router,
            store,
            i18n,
            render: h => h(App),
        })
            .$mount('#app');
    })
    .catch(error => {
        console.log(error);

        // eslint-disable-next-line no-undef
        gtag('event', 'exception', {
            'description': error,
            'fatal': true,
        });
    });

appInfo.translations([i18n.locale]);
